import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';

ErrorPageArea.propTypes = {
  errorTips: PropTypes.string,
  onReloadBtnClick: PropTypes.func,
  reloadBtnText: PropTypes.string
};

ErrorPageArea.defaultProps = {
  errorTips: '加载失败，请点击重试',
  reloadBtnText: '重试'
};

export default function ErrorPageArea(props) {
  const { errorTips, onReloadBtnClick, reloadBtnText } = props;
  return (
    <div className="area-error-box">
      <h3>{errorTips}</h3>
      <div onClick={() => { onReloadBtnClick(); }}>
        <Icon name="refresh" />
        <span>{reloadBtnText}</span>
      </div>
    </div>
  );
}
